/**
 * 便名として入力された文字列が便名の形式になっているかを検証する。
 * @param value 検証したい値。
 */
export function isValidFLight(value: string) {
  const flightFormat = RegExp(/^([a-zA-Zａ-ｚＡ-Ｚ0-9０-９]{2}|[a-zA-Zａ-ｚＡ-Ｚ]{3})[0-9０-９]{1,4}$/);
  return flightFormat.test(value);
}
